import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import {MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from "../../cc-base.component";
import {TableColumnConfig} from "../../../model/api/table-column-config";

@Component({
  selector: 'app-cc-cell-dispatcher[record][columnDef][columnIndex][rowIndex][tableValueMap]',
  templateUrl: './cc-cell-dispatcher.component.html',
  styleUrls: ['./cc-cell-dispatcher.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CcCellDispatcherComponent extends CcBaseComponent {

  @Input()
  record: any;
  @Output()
  recordChange = new EventEmitter<any>();

  @Input()
  columnDef: TableColumnConfig;

  @Input()
  columnIndex:number;
  @Input()
  rowIndex:number;

  @Input()
  tableValueMap = {};

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);
  }

  recordChanged() {
    // if (fieldConfig.type === this.FieldTypes.MULTISELECT
    //   || fieldConfig.type === this.FieldTypes.DROPDOWN
    //   || fieldConfig.type === this.FieldTypes.LISTBOX
    //   || fieldConfig.type === this.FieldTypes.PICKLIST
    //   || fieldConfig.type === this.FieldTypes.INTEGER
    //   || fieldConfig.type === this.FieldTypes.DECIMAL
    // ) {
    //   this.formRecord[fieldConfig.field] = record.value;
    // } else if (fieldConfig.type === this.FieldTypes.SINGLERICHFIELD
    //   || fieldConfig.type === this.FieldTypes.RICHFIELD
    //   || fieldConfig.type === this.FieldTypes.ADDDELETEFIELD
    //   || fieldConfig.type === this.FieldTypes.TABLEFORMFIELD
    //   || fieldConfig.type === this.FieldTypes.MAPFIELD)
    //   this.formRecord[fieldConfig.field] = record;
    // if (fieldConfig.changed)
    //   fieldConfig.changed(record, this.formRecord);
    // this.reloadFieldValueMap();
    // this.recordChange.emit(this.record);
  }
}
